import { render, staticRenderFns } from "./YuqingliangqushiDetail.vue?vue&type=template&id=7665fbf0&scoped=true&"
import script from "./YuqingliangqushiDetail.vue?vue&type=script&lang=js&"
export * from "./YuqingliangqushiDetail.vue?vue&type=script&lang=js&"
import style0 from "./YuqingliangqushiDetail.vue?vue&type=style&index=0&id=7665fbf0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7665fbf0",
  null
  
)

export default component.exports